import * as React from 'react';

import { IPublishedConnectionDetailInfo } from '../../ts/models/IPublishedConnectionInfo';
import {
  PublishedConnectionTablesGrid,
  PublishedConnectionTablesGridProps,
} from './tables/PublishedConnectionTablesGrid';

export type PublishedConnectionOverviewSubplaceProps = Readonly<{
  publishedConnectionDetailInfo: IPublishedConnectionDetailInfo;
}>;

export class PublishedConnectionOverviewSubplace extends React.Component<PublishedConnectionOverviewSubplaceProps, {}> {
  private getPublishedConnectionTablesGridProps = (): PublishedConnectionTablesGridProps => {
    return {
      publishedConnectionDetailInfo: this.props.publishedConnectionDetailInfo
    };
  };

  public render(): JSX.Element {
    return (
      <PublishedConnectionTablesGrid {...this.getPublishedConnectionTablesGridProps()} />
    );
  }
}
